import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'index',
    // component: () => import( '../views/kubi-index')
    component: () => import( '../views/index')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import( '../views/index')
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import( '../views/blog')
  },
  {
    path: '/help',
    name: 'help',
    component: () => import( '../views/help')
  },
  {
    path: '/price',
    name: 'price',
    component: () => import( '../views/price')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import( '../views/dashboard')
  },
  {
    path: '/career',
    name: 'career',
    component: () => import( '../views/career')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import( '../views/about')
  },
  {
    path: '/team',
    name: 'team',
    component: () => import( '../views/team')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import( '../views/register')
  },
  {
    path: '/finishRegister',
    name: 'finishRegister',
    component: () => import( '../views/finishRegister')
  },
  {
    path: '/serviceProviderRegiste',
    name: 'serviceProviderRegiste',
    component: () => import( '../views/serviceProviderRegiste')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import( '../views/contact')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import( '../views/faq')
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import( '../views/wallet')
  },
  {
    path: '/downloadIos',
    name: 'downloadIos',
    component: () => import( '../views/about/downloadIos')
  },




]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
